/**
 * CUSTOM: Kædevælger på produktsiden.
 * Markup: snippets/custom-chain-selector.liquid · CSS: assets/custom-chain-selector.css
 *
 * Flyttet fra inline <script> i snippets/block-chain-selector.liquid (7/10 2026).
 *
 * Rettelser 7/10 2026 (fundet ved kurv-test):
 * - Varianten findes via CustomVariantSync (assets/custom-variant-sync.js), så ALLE valg bevares
 *   (fx "Antal Navne" på Sienna blev før nulstillet til "2 Navne").
 * - Kæder der ikke findes/er udsolgt i den valgte længde vises som "IKKE TILGÆNGELIG".
 * - Skiftes længde til en kombination der ikke findes, nulstilles kædevalget, og "Læg i kurv"
 *   stoppes med en fejl (før kom den forrige kæde stille med i kurven).
 * - Det skjulte felt properties[Kæde] er fjernet (lå uden for formularen og blev aldrig sendt med).
 */
document.addEventListener('DOMContentLoaded', function() {
  const chainDropdownToggle = document.querySelector('.chain-dropdown-toggle');
  const chainPanelOverlay = document.querySelector('.chain-panel-overlay');
  const desktopPanel = document.querySelector('.chain-panel.desktop-panel');
  const mobilePanel = document.querySelector('.chain-panel.mobile-panel');
  const closePanel = document.querySelector('.close-panel');
  const closePanelMobile = document.querySelector('.close-panel-mobile');
  const selectedChainText = document.querySelector('.selected-chain-text');
  // Valgt kæde (state). Kæden står i variantens navn i kurven – derfor intet properties-felt.
  const chainProperty = { value: '' };
  const errorDiv = document.querySelector('.chain-error');

  const chainSelector = document.querySelector('.chain-selector');
  const variantsJson = document.querySelector('[data-chain-variants]');
  if (!chainSelector || !variantsJson) return;
  const variants = JSON.parse(variantsJson.textContent);

  // Hvilken valgmulighed indeholder kæden (0 = option1, 1 = option2)
  const chainOptIndex = Number(chainSelector.dataset.chainOptIndex);
  const chainOptKey = 'option' + (chainOptIndex + 1);

  let selectedChain = selectedChainText.textContent.trim();
  if (selectedChain === 'Vælg kæde') {
    selectedChain = '';
  }

  // Meld kædens option-index + valgte værdi til CustomVariantSync
  chainSelector.dataset.variantOptionIndex = String(chainOptIndex);
  function publishChain() {
    chainSelector.dataset.variantOptionValue = chainProperty.value || '';
  }
  chainProperty.value = selectedChain;
  publishChain();

  const isMobile = window.innerWidth <= 767;

  if (isMobile) {
    const desktopOptions = document.querySelectorAll('.desktop-panel .chain-option');
    const mobileGrid = document.querySelector('.chain-grid-mobile');

    desktopOptions.forEach(option => {
      const clone = option.cloneNode(true);
      mobileGrid.appendChild(clone);
    });
  }

  function getSelectedLength() {
    const lengthSelect = document.querySelector('[data-index="option1"] select, select[data-index="option1"]');
    if (lengthSelect && lengthSelect.value) {
      return lengthSelect.value;
    }

    const lengthRadio = document.querySelector('[data-index="option1"] input[type="radio"]:checked');
    if (lengthRadio) {
      return lengthRadio.value;
    }

    for (let variant of variants) {
      if (variant.available) {
        return variant.option1;
      }
    }

    return '';
  }

  // Pris i butikkens format – CUSTOM 12/10 2026: samme som custom-variant-sync.js (var hardcodet ' kr.')
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  // Function to update the displayed price on the product page
  function updateDisplayedPrice(variant) {
    if (!variant) return;
    if (window.CustomVariantSync) {
      window.CustomVariantSync.updatePrice(variant);
      return;
    }

    // Update main price
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) {
      priceEl.innerHTML = formatMoney(variant.price);

      // Add or remove sale-price class
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('sale-price');
      } else {
        priceEl.classList.remove('sale-price');
      }
    }

    // Update compare at price
    const compareEl = document.querySelector('[data-compare-price]');
    const compareWrap = document.querySelector('[data-product-price-wrap]');
    if (compareEl && compareWrap) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.innerHTML = formatMoney(variant.compare_at_price);
        compareWrap.classList.remove('hide');
      } else {
        compareEl.innerHTML = '';
        compareWrap.classList.add('hide');
      }
    }
  }

  function updateMotionVariantSelector(variantId) {
    const targetVariant = variants.find(v => v.id === variantId);
    if (!targetVariant) return;

    if (chainOptIndex === 1) {
      // ---- Eksisterende adfærd: Længde = option1, Kæde = option2 (uændret) ----
      const lengthSelect = document.querySelector('[data-index="option1"] select, select[data-index="option1"]');
      if (lengthSelect && lengthSelect.value !== targetVariant.option1) {
        lengthSelect.value = targetVariant.option1;
        lengthSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      let chainSelect = document.querySelector('[data-index="option2"] select, select[data-index="option2"]');
      if (!chainSelect) {
        const variantWrapper = document.querySelector('.variant-wrapper');
        if (variantWrapper) {
          const hiddenChainWrapper = document.createElement('div');
          hiddenChainWrapper.style.display = 'none';
          hiddenChainWrapper.innerHTML = `
            <select data-variant-input data-index="option2">
              ${variants.map(v => `<option value="${v.option2}">${v.option2}</option>`).join('')}
            </select>
          `;
          variantWrapper.parentElement.appendChild(hiddenChainWrapper);
          chainSelect = hiddenChainWrapper.querySelector('select');
        }
      }

      if (chainSelect && chainSelect.value !== targetVariant.option2) {
        chainSelect.value = targetVariant.option2;
        chainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      // ---- Ny adfærd: Kæde er produktets eneste/første valgmulighed (option1) ----
      const chainVal = targetVariant.option1;
      const sel = document.querySelector('[data-index="option1"] select, select[data-index="option1"]');
      if (sel && sel.value !== chainVal) {
        sel.value = chainVal;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const safeVal = (window.CSS && CSS.escape) ? CSS.escape(chainVal) : chainVal;
      const radio = document.querySelector('[data-index="option1"] input[type="radio"][value="' + safeVal + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Update variant ID input
    const variantIdInput = document.querySelector('[name="id"]');
    if (variantIdInput) {
      variantIdInput.value = variantId;
    }

    // Update the displayed price immediately
    updateDisplayedPrice(targetVariant);

    // Also update URL with variant ID
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }

    // Trigger Motion theme's variant change event
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      form.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: targetVariant }
      }));
    }

    // Dispatch on document level too for Motion theme
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variant: targetVariant }
    }));

    // Sørg for at den endelige variant i formularen er præcis den valgte
    if (window.CustomVariantSync) window.CustomVariantSync.apply(targetVariant);
  }

  function findCorrectVariant(chainValue) {
    // Match på ALLE valgmuligheder (længde, kæde, antal navne …) – kun tilgængelige varianter
    if (window.CustomVariantSync) {
      const sync = window.CustomVariantSync;
      const match = sync.findVariant(variants, sync.getSelectedOptions({ [chainOptIndex]: chainValue }));
      return match && match.available ? match : undefined;
    }

    // Kæde er produktets eneste/første valgmulighed: match direkte på option1
    if (chainOptIndex === 0) {
      return variants.find(v => v.option1 === chainValue && v.available)
          || variants.find(v => v.option1 === chainValue);
    }

    // Ellers (kæde = 2. valgmulighed): kombiner med længde som hidtil
    const selectedLength = getSelectedLength();

    if (!selectedLength) {
      for (let variant of variants) {
        if (variant.option2 === chainValue && variant.available) {
          return variant;
        }
      }
    }

    const matchingVariant = variants.find(variant => {
      return variant.option1 === selectedLength &&
             variant.option2 === chainValue &&
             variant.available;
    });

    return matchingVariant;
  }

  chainDropdownToggle.addEventListener('click', function() {
    chainPanelOverlay.style.display = 'block';
    // CUSTOM 12/10 2026: lås også <html> (iOS ignorerer body alene) – ellers scroller siden bagved, Safaris
    // værktøjslinje skifter størrelse, og skuffens bund slipper skærmkanten
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    if (window.innerWidth <= 767) {
      mobilePanel.style.display = 'block';
      setTimeout(() => {
        mobilePanel.style.transform = 'translateY(0)';
      }, 10);
    } else {
      desktopPanel.style.display = 'block';
      setTimeout(() => {
        desktopPanel.style.transform = 'translateX(0)';
      }, 10);
    }
  });

  function closePanelFunction() {
    if (window.innerWidth <= 767) {
      mobilePanel.style.transform = 'translateY(100%)';
    } else {
      desktopPanel.style.transform = 'translateX(100%)';
    }

    setTimeout(() => {
      chainPanelOverlay.style.display = 'none';
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      mobilePanel.style.display = 'none';
      desktopPanel.style.display = 'none';
    }, 300);
  }

  closePanel.addEventListener('click', closePanelFunction);
  closePanelMobile.addEventListener('click', closePanelFunction);

  chainPanelOverlay.addEventListener('click', function(e) {
    if (e.target === chainPanelOverlay) {
      closePanelFunction();
    }
  });

  function setupChainSelection(container) {
    const chainOptions = container.querySelectorAll('.chain-option');

    chainOptions.forEach(option => {
      const selectBtn = option.querySelector('.chain-select-btn');

      selectBtn.addEventListener('click', function(e) {
        e.stopPropagation();

        if (this.disabled) return;

        document.querySelectorAll('.chain-select-btn').forEach(btn => {
          if (!btn.disabled) {
            btn.style.background = '#ffae5a';
            btn.style.color = 'white';
            btn.style.border = 'none';
            btn.dataset.selected = 'false';

            const price = btn.dataset.price || '0';
            if (price === '0') {
              btn.textContent = 'VÆLG | GRATIS';
            } else {
              btn.textContent = 'VÆLG | +' + price + ' KR';
            }
          }
        });

        this.style.background = 'white';
        this.style.color = '#333';
        this.style.border = '1px solid #ccc';
        this.textContent = 'VALGT';
        this.dataset.selected = 'true';

        selectedChain = option.dataset.chain;
        selectedChainText.textContent = selectedChain;
        chainProperty.value = selectedChain;
        publishChain();

        const matchingVariant = findCorrectVariant(selectedChain);
        if (matchingVariant) {
          updateMotionVariantSelector(matchingVariant.id);
          errorDiv.style.display = 'none';
          chainDropdownToggle.style.borderColor = '';
        } else {
          // Kombinationen findes ikke – behold IKKE den forrige kæde i formularen
          clearChain();
          errorDiv.textContent = 'Denne kæde findes ikke i den valgte længde';
          errorDiv.style.display = 'block';
        }
        updateChainAvailability();

        setTimeout(() => {
          closePanelFunction();
        }, 300);
      });
    });
  }

  function clearChain() {
    selectedChain = '';
    chainProperty.value = '';
    publishChain();
    selectedChainText.textContent = 'Vælg kæde';
    updateButtonStates();
  }

  // Marker kæder, der ikke findes/er udsolgt med de øvrige valg (fx længden), som "IKKE TILGÆNGELIG"
  function updateChainAvailability() {
    if (!window.CustomVariantSync) return;
    document.querySelectorAll('.chain-option').forEach(option => {
      const btn = option.querySelector('.chain-select-btn');
      const available = !!findCorrectVariant(option.dataset.chain);
      btn.disabled = !available;
      if (!available) {
        btn.dataset.selected = 'false';
        btn.style.background = '';
        btn.style.color = 'white';
        btn.style.border = 'none';
        btn.textContent = 'IKKE TILGÆNGELIG';
      }
    });
    updateButtonStates();
  }

  // Når længde/antal navne ændres: behold kæden hvis kombinationen findes, ellers nulstil
  function onOtherOptionsChanged() {
    if (selectedChain && window.CustomVariantSync) {
      const match = findCorrectVariant(selectedChain);
      if (match) {
        window.CustomVariantSync.apply(match);
      } else {
        clearChain();
      }
    }
    updateChainAvailability();
  }

  document.querySelectorAll('[data-index] select, select[data-index]').forEach(select => {
    if (select.closest('.chain-selector')) return;
    select.addEventListener('change', () => setTimeout(onOtherOptionsChanged, 0));
  });
  document.addEventListener('custom:variant-options-changed', () => setTimeout(onOtherOptionsChanged, 0));

  setupChainSelection(desktopPanel);
  if (isMobile) {
    setupChainSelection(mobilePanel);
  }

  function updateButtonStates() {
    document.querySelectorAll('.chain-select-btn').forEach(btn => {
      const optionElement = btn.closest('.chain-option');
      if (optionElement && optionElement.dataset.chain === selectedChain) {
        btn.style.background = 'white';
        btn.style.color = '#333';
        btn.style.border = '1px solid #ccc';
        btn.textContent = 'VALGT';
        btn.dataset.selected = 'true';
      } else if (!btn.disabled) {
        btn.style.background = '#ffae5a';
        btn.style.color = 'white';
        btn.style.border = 'none';
        btn.dataset.selected = 'false';
        const price = btn.dataset.price || '0';
        btn.textContent = price === '0' ? 'VÆLG | GRATIS' : 'VÆLG | +' + price + ' KR';
      }
    });
  }

  if (selectedChain) {
    updateButtonStates();
    // Also update price on initial load for default chain
    const initialVariant = findCorrectVariant(selectedChain);
    if (initialVariant) {
      updateDisplayedPrice(initialVariant);
    }
  }

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      const newChain = e.detail.variant[chainOptKey];
      if (newChain !== selectedChain) {
        selectedChain = newChain;
        selectedChainText.textContent = selectedChain;
        chainProperty.value = selectedChain;
        publishChain();
        updateButtonStates();
      }
    }
  });

  // Stop "Læg i kurv" hvis ingen gyldig kæde er valgt (Motion tilføjer via AJAX, så submit-stop alene er ikke nok)
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      if (document.querySelectorAll('.chain-option').length > 0 && !chainProperty.value) {
        e.preventDefault();
        e.stopPropagation();
        errorDiv.textContent = 'Vælg venligst en kæde type';
        errorDiv.style.display = 'block';
        chainDropdownToggle.style.borderColor = '#ff0000';
      }
    });
  }

  updateChainAvailability();

  const form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      const hasChainOptions = document.querySelectorAll('.chain-option').length > 0;
      if (hasChainOptions && (!chainProperty.value || chainProperty.value === '')) {
        e.preventDefault();
        errorDiv.style.display = 'block';
        chainDropdownToggle.style.borderColor = '#ff0000';
      }
    });
  }
});
